module.exports = __webpack_public_path__ + "img/tech03.bdb023e6.jpg";